import React from 'react';
import { motion } from 'framer-motion';
const artists = [{
  name: 'Jan Kowalski',
  role: 'Mistrz Kaligrafii',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  desc: 'Specjalista od złocenia i klasycznego liternictwa.'
}, {
  name: 'Anna Nowak',
  role: 'Ilustratorka',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  desc: 'Tworzy ręcznie malowane ornamenty i detale.'
}, {
  name: 'Piotr Wiśniewski',
  role: 'Stolarz Artystyczny',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  desc: 'Przygotowuje drewniane podkłady pod nasze szyldy.'
}];
export function Gallery() {
  return <section className="py-24 bg-[#1a3a2e] text-[#f4f1e8] relative overflow-hidden" data-id="element-33">
      <div className="absolute inset-0 bg-texture-grain opacity-20 pointer-events-none" data-id="element-34"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-35">
        <div className="text-center mb-20" data-id="element-36">
          <motion.h2 initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="font-display text-5xl md:text-7xl text-[#d4af37] mb-2" data-id="element-37">
            Nasi Artyści
          </motion.h2>
          <p className="font-script text-2xl text-[#f4f1e8] opacity-80" data-id="element-38">
            Poznaj zespół KMI Polska
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-39">
          {artists.map((artist, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="group" data-id="element-40">
              <div className="relative p-4 bg-[#f4f1e8] shadow-2xl transform rotate-1 transition-transform duration-500 group-hover:rotate-0" data-id="element-41">
                {/* Photo Frame */}
                <div className="relative aspect-[3/4] overflow-hidden border-2 border-[#1a3a2e] mb-4 bg-gray-200" data-id="element-42">
                  <div className="absolute inset-0 bg-sepia-50 mix-blend-multiply z-10 pointer-events-none bg-[#704214] opacity-20" data-id="element-43"></div>
                  <img src={artist.image} alt={artist.name} className="w-full h-full object-cover filter grayscale contrast-125 transition-transform duration-700 group-hover:scale-110" data-id="element-44" />
                  {/* Corner decorations */}
                  <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-[#d4af37] z-20" data-id="element-45"></div>
                  <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-[#d4af37] z-20" data-id="element-46"></div>
                  <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-[#d4af37] z-20" data-id="element-47"></div>
                  <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-[#d4af37] z-20" data-id="element-48"></div>
                </div>

                <div className="text-center" data-id="element-49">
                  <h3 className="font-display text-3xl text-[#1a3a2e] mb-1" data-id="element-50">
                    {artist.name}
                  </h3>
                  <p className="font-script text-[#d4af37] text-xl mb-3" data-id="element-51">
                    {artist.role}
                  </p>
                  <p className="font-serif text-[#2c2c2c] italic text-sm border-t border-[#1a3a2e] pt-3 mx-8" data-id="element-52">
                    {artist.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}